import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import AddAccommodationsModal from '../../containers/global-settings/AddAccommodationsModal'
import EditAccommodationsModal from './EditAccommodationsModal'
import RemoveAccommodationsModal from '../../containers/global-settings/RemoveAccommodationsModal'
import SettingList from './SettingList'
import { IAccommodation } from 'src/types'
import BackToList from '../ui/BackToList'

interface IAccommodationsPaneProps extends RouteComponentProps {
  accomodations: IAccommodation[]
}

export default class AccommodationsPane extends React.Component<IAccommodationsPaneProps> {
  public render() {
    const accomodations = []
    for (const index of Object.keys(this.props.accomodations)) {
      const accomodation = this.props.accomodations[index]
      accomodations.push({
        label: accomodation.name,
        id: accomodation.id
      })
    }
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddAccommodationsModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveAccommodationsModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditAccommodationsModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Accommodations</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/accommodations/create'
            >
              <Plus className='svg-white mr1' />
              Add Accommodations
            </Link>
          </div>
          <hr />
          <div>
            <p className='h5 bold pl2 font-black'>Accommodations List</p>
            <div className='pl3 pr3 col-4'>
              <SettingList baseUrl={this.props.match.path} settings={accomodations} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AccommodationsPane.tsx